module.exports = "<div>\n  eval page\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/views/eval/eval.html
// module id = ./src/views/eval/eval.html
// module chunks = 4